/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type GetFeatureFlagStatusesPathParams = NonNullable<operations['getFeatureFlagStatuses']['parameters']['path']>;

export interface Input extends GetFeatureFlagStatusesPathParams {
  apiVersion?: string;
}

export async function getFeatureFlagStatuses(
  { apiVersion, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/flag-statuses/{projectKey}/{environmentKey}', {
    params: { path },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
